import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import MarketsContext from "context/MarketsContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import UserService from "services/UserService";
import axios from "axios";
import { getAccountMeters } from "services/ConfigServices";
import { metersStatusData } from "variables/lists/markets";
import moment from "moment";

const UploadButton = styled.div`
  margin-left: 15px;
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useAddMetersTable(membershipgroup, marketmeters) {
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const marketContext = useContext(MarketsContext);
  const { market, setMarket } = marketContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  console.log(market);
  const url = getAccountMeters(null, market.parameters.general.energy, membershipgroup);
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(false);

  const refreshTable = () =>
  {
    setRefresh(!refresh);
  }

  useEffect(() => {
    if (membershipgroup) 
    { 
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,        
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        let filtered = {meters : response.data.meters.filter((obj) => !marketmeters.map((s) => s.accountmeterid).includes(obj.id))} //marketmeters should not include meter
        setResults(filtered);
        setLoading(false);
      }
      fetchData();
    }
    else
    {
      setResults({});
      setLoading(false);
    }
  }, [membershipgroup]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-20px", marginLeft: "-39px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `meters`, []).filter(
    (item) =>
      (item.meternumber && item.meternumber.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.details.segment && item.details.segment.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.details.profil && item.details.profil.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.details.acheminement && item.details.acheminement.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);

    return (
      <>
        <TableName></TableName>
        {/* <FilterComponent
          key="FilterComponent"
          //onUpload={handleClick}
          handleClick={handleClick}
          handleClose={handleClose}
        /> */}
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
      </>
    );
  }, [filterText, resetPaginationToggle]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable
  };
}
